import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionDetailsReport } from './Pages';

export const LeafCollectionDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafCollectionDetailsReport} />
    </Fragment>
)